export const SEARCH_EVENTNAME = 'SEARCH_EVENTNAME'

export const SEARCH_EVENTNAME_action = (data) => {
    return {
        type: SEARCH_EVENTNAME,
        data: data
    }
}

export const SEARCH_EVENTCREATOR = 'SEARCH_EVENTCREATOR'

export const SEARCH_EVENTCREATOR_action = (data) => {
    return {
        type: SEARCH_EVENTCREATOR,
        data: data
    }
}